{
  "nl": {
    "materials": {
      "collectionEmpty": {
        "communityTab": "Bekijk het materiaal van de fobizz Community.",
        "partnerTab": "Bekijk het materiaal van fobizz & Partners.",
        "title": "Niets gevonden?",
        "viewCommunityMaterial": "Naar het materiaal van de fobizz Community",
        "viewPartnerMaterial": "Naar het materiaal van fobizz & Partners"
      },
      "collectionTeaser": {
        "linkName": "Meer informatie",
        "title": "Volledige lesontwerpen in de collecties"
      },
      "filters": {
        "international": {
          "false": "DE",
          "true": "EN"
        },
        "language": "Taal",
        "order": {
          "label": "Sorteer op",
          "newest": "Nieuwste",
          "relevance": "Relevantie"
        }
      },
      "galleryTeaser": {
        "linkName": "Meer informatie",
        "title": "Zo gebruik je de materialen uit de galerij optimaal"
      },
      "headings": {
        "toTeach": "Deze inhoud is afkomstig van onze <a href=\"https://app.fobizz.com/partners/34-to-teach\" target=\"_blank\">partner to teach</a>. Met een gratis to teach-account kun je onbeperkt bestaande to teach-inhoud gebruiken en elke maand 10 nieuwe aanmaken. <a href=\"https://app.fobizz.com/de/help/articles/271-to-teach-abo-kostenlos\" target=\"_blank\">Meer informatie.</a>"
      },
      "howTo": {
        "header": {
          "heading": "De fobizz Galerij - dit kun je verwachten",
          "list_html": "<li><i class='bi bi-check-lg'></i>Inspiratie van andere docenten voor jouw les</li>\n<li><i class='bi bi-check-lg'></i>Praktijkgeteste en gratis materialen om te hergebruiken</li>\n<li><i class='bi bi-check-lg'></i>Eenvoudig aanpassen van sjablonen en voorbeelden met de fobizz Tools</li>\n<li><i class='bi bi-check-lg'></i>Tijdsbesparing door het uitwisselen van materialen en lesideeën</li>\n<li><i class='bi bi-check-lg'></i>Collecties met kant-en-klare lesontwerpen over specifieke onderwerpen</li>"
        },
        "recommendations": {
          "heading": "Ontdek actuele collecties"
        },
        "terms": {
          "collections": {
            "description_html": "In de galerij vind je verzamelingen lesmateriaal <strong>over specifieke onderwerpen</strong>. Je kunt er losse elementen uitkiezen en aanpassen, of direct <strong>volledige lesontwerpen</strong> met al het benodigde materiaal in de les gebruiken.",
            "heading": "Collecties?"
          },
          "copyright": {
            "description_html": "In de geest van <strong>OER</strong> (Open Educational Resources) vallen alle inhoud die docenten in de galerij publiceren onder de <a href=\"https://creativecommons.org/licenses/by/3.0/de/\" target=\"_blank\">Creative Commons-licentie CC-BY</a>. Dat betekent dat je het gratis mag gebruiken, bewerken en verder verspreiden.",
            "heading": "Auteursrecht?"
          },
          "description": "De volgende termen kom je tegen in de galerij. Wat ze inhouden, lees je hier!",
          "heading": "Wat is er eigenlijk met...",
          "link": "Ontdek nu lesmateriaal",
          "remix": {
            "description_html": "Met slechts één klik op de <strong>Remix-knop</strong> kun je elk materiaal uit de galerij naar je <strong>eigen opslag</strong> kopiëren - als een digitale kopieersjabloon. Gebruik het materiaal direct in de les of pas afzonderlijke elementen flexibel aan voor gebruik.",
            "heading": "Remix?"
          }
        },
        "tile": {
          "heading": "Vind inhoud die precies bij jou past",
          "help": {
            "author": "Auteur van het materiaal",
            "bookmark": "Hart voor je verlanglijstje",
            "kind": "Soort inhoud"
          },
          "link": "Terug naar de galerij",
          "list_html": "<li><i class='bi bi-check-lg'></i>Zoek op <strong>onderwerpen en trefwoorden</strong> en verfijn de resultaten verder: op aanbevolen schooltype, leeftijdsgroep of vak.</li>\n<li><i class='bi bi-check-lg'></i>Bewaar interessante inhoud voor later door op het hart te klikken en vind deze terug in je <strong>persoonlijke verlanglijstje</strong>.</li>\n<li><i class='bi bi-check-lg'></i>Zie in één oogopslag de <strong>populariteit van een materiaal</strong>. Aan het aantal remixes zie je hoe vaak het al is hergebruikt.</li>",
          "material_title": "Nooit meer huiswerk? AI - Mogelijkheden en grenzen"
        },
        "title": "Alles wat je moet weten over de galerij"
      },
      "labels": {
        "approvedUserIds": "Partner",
        "filterCollection": "Collectie",
        "galleryCommunityPlaceholder": "Doorzoek fobizz Community Materiaal",
        "galleryFallbackPlaceholder": "Doorzoek inhoud",
        "galleryPlaceholder": "Doorzoek fobizz & Partner Materiaal",
        "galleryToTeachPlaceholder": "Doorzoek to teach inhoud",
        "models": "Materiaaltypen"
      },
      "searchPlaceholder": "Doorzoek fobizz materiaal...",
      "toTeachImport": {
        "importFailed": "Importeren mislukt. Probeer het opnieuw.",
        "importNotFound": "Het werkblad is niet gevonden.",
        "importReady": "Je to teach werkblad is succesvol geïmporteerd!"
      }
    }
  }
}
